import React, { useLayoutEffect, useMemo } from 'react';
import { Gesture, GestureDetector } from 'react-native-gesture-handler';
import { View, StyleSheet, StatusBar } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, Reanimated3DefaultSpringConfig, withSpring, } from 'react-native-reanimated';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
const MAX_SCALE = 1;
const MIN_SCALE = 1;
const ViewImageScreen = ({ route, navigation }) => {
    const { source, title } = route.params;
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => <NavigationCloseButton inWebHeader onPress={navigation.goBack} colorKey="white"/>,
            headerTintColor: 'white',
            title: title ?? '',
        });
    }, [title]);
    const scale = useSharedValue(1);
    const savedScale = useSharedValue(1);
    const offset = useSharedValue({ x: 0, y: 0 });
    const start = useSharedValue({ x: 0, y: 0 });
    const pinchGesture = useMemo(() => Gesture.Pinch()
        .onUpdate((e) => {
        scale.value = savedScale.value * e.scale;
    })
        .onEnd(() => {
        savedScale.value = scale.value;
        if (savedScale.value < MIN_SCALE) {
            // do not allow zooming out below original/min scale
            scale.value = withSpring(MIN_SCALE, {
                ...Reanimated3DefaultSpringConfig,
                stiffness: 60,
                overshootClamping: true,
            });
            savedScale.value = MIN_SCALE;
        }
        else if (savedScale.value > MAX_SCALE) {
            // do not allow zooming beyond max scale
            scale.value = withSpring(MAX_SCALE, {
                ...Reanimated3DefaultSpringConfig,
                stiffness: 60,
                overshootClamping: true,
            });
            savedScale.value = MAX_SCALE;
        }
    }), [scale, savedScale]);
    const panGesture = useMemo(() => Gesture.Pan()
        .enabled(true)
        .onUpdate((e) => {
        offset.value = {
            x: e.translationX + start.value.x,
            y: e.translationY + start.value.y,
        };
    })
        .onEnd(() => {
        // if user take off finger while moving image in x and y direction, take image to its original place.
        offset.value = {
            x: withSpring(0, {
                ...Reanimated3DefaultSpringConfig,
                stiffness: 60,
                overshootClamping: true,
            }),
            y: withSpring(0, {
                ...Reanimated3DefaultSpringConfig,
                stiffness: 60,
                overshootClamping: true,
            }),
        };
        start.value = {
            x: 0,
            y: 0,
        };
    }), [offset, start]);
    const animatedStyle = useAnimatedStyle(() => ({
        transform: [{ scale: scale.value }, { translateX: offset.value.x }, { translateY: offset.value.y }],
    }));
    const composed = Gesture.Simultaneous(pinchGesture, panGesture);
    return (<View style={styles.container}>
      <StatusBar barStyle="light-content" animated/>
      <GestureDetector gesture={composed}>
        <Animated.Image source={source} style={[styles.imgContainer, animatedStyle]} resizeMode="contain"/>
      </GestureDetector>
    </View>);
};
export default ViewImageScreen;
const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'black',
    },
    imgContainer: {
        width: '100%',
        height: '100%',
    },
});
